import { render, staticRenderFns } from "./AdminAppShowCertificatePhoto.vue?vue&type=template&id=5911f919&scoped=true"
import script from "./AdminAppShowCertificatePhoto.vue?vue&type=script&lang=js"
export * from "./AdminAppShowCertificatePhoto.vue?vue&type=script&lang=js"
import style0 from "./AdminAppShowCertificatePhoto.vue?vue&type=style&index=0&id=5911f919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5911f919",
  null
  
)

export default component.exports